<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Mission Voting camping</h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="">
    <div class="section-lg">
        <div class="container">
            <div class="text-justify">
                  <p>Empowering Voices, Strengthening Democracy! The 'Mission Voting Campaign' at G H Raisoni College of Arts, Commerce & Science, Nagpur, saw an inspiring turnout with students being encouraged to vote by actors Sachin Pilgaonkar, Supriya Pilgaonkar, and Swapnil Joshi. Organized by Bahujan Vichar Manch, the event was also graced by Dr. Vivek Kapur, Director of GHRCE Nagpur. Let's make every vote count! #MissionVoting #VoteForChange #RaisoniCollege #DemocracyInAction #NagpurEvents #StudentEmpowerment</p>
            </div>
            <div class="row mb-20 mt-5">
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/mission-voting-3.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/mission-voting-3.avif" alt="Mission Voting camping | Ghrcacsn" title="Mission Voting camping | Ghrcacsn">
                        <div class="gallery-overlay"></div>  
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/mission-voting-4.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/mission-voting-4.avif" alt="Mission Voting camping | Ghrcacsn" title="Mission Voting camping | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                      <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/mission-voting-5.avif" data-lightbox="example-set"
                        data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/mission-voting-5.avif" alt="Mission Voting camping | Ghrcacsn" title="Mission Voting camping | Ghrcacsn">
                        <div class="gallery-overlay"></div>    
                    </a>
                    </div>
                </div>
              </div>
        </div>
    </div>
</section>